export type GuestAuthDeepLinkView =
  | 'login'
  | 'signup'
  | 'signupUser'
  | 'signupClub'
  | 'googleRoleChoose'
  | 'success'

export function guestAuthHref(view: GuestAuthDeepLinkView): string {
  return `/?authModal=${view}`
}
